import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { ClientPricing } from "@hooks/billing/useClientPricing";

interface OrganizationOwnedSeatPricingParams {
    clientPricing: ClientPricing;
    plan: FLAT_RATE_PLANS;
}

export const isOrganizationOwnedComplimentaryPlan = ({
    clientPricing,
    plan,
}: OrganizationOwnedSeatPricingParams): boolean =>
    clientPricing.organizationOwnedComplimentaryPlans.includes(plan);

export const getOrganizationOwnedSeatMonthlyAmountCents = ({
    clientPricing,
    plan,
}: OrganizationOwnedSeatPricingParams): number =>
    isOrganizationOwnedComplimentaryPlan({ clientPricing, plan })
        ? 0
        : clientPricing.organizationOwnedNextSeatPricing[plan];
